import * as types from './types';

export const reducer = (state, action) => {
  switch (action.type) {
    case types.USER_ADD: {
      return { ...state, user: action.user };
    }
    case types.USER_REMOVE: {
      return {
        ...state,
        user: {
          isAnonymous: true,
        },
      };
    }
  }

  return { ...state };
};
